import { PerformanceDTOTypeEnum } from "../openapi-generated-client";

function validateYouTubeUrl(urlToParse: string){
    if (urlToParse) {
        var regExp = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        if (urlToParse.match(regExp)) {
            return true;
        }
    }
    return false;
}

function validateSpotifyUrl(urlToParse: string) {
    return /^(spotify:|https:\/\/[a-z]+\.spotify\.com\/)/.test(urlToParse);
}

function validateSoundcloudUrl(urlToParse: string) {
    return /^(?:https?:\/\/)((?:www\.)|(?:m\.))?soundcloud\.com\/[a-z0-9](?!.*?(-|_){2})[\w-]{1,23}[a-z0-9](?:\/.+)?$/.test(urlToParse);
}

function getUrlType(url: string) {
    if(validateSoundcloudUrl(url)) {
        return PerformanceDTOTypeEnum.Soundcloud;
    }
    if(validateSpotifyUrl(url)) {
        return PerformanceDTOTypeEnum.Spotify;
    }
    if(validateYouTubeUrl(url)) {
        return PerformanceDTOTypeEnum.Youtube;
    }
    return null;
}

enum URLType {
    LOCAL, SPOTIFY, YOUTUBE, SOUNDCLOUD, NOTHING
}

function getUrlTypeName(type: URLType) {
    switch(type) {
        case URLType.SPOTIFY:
            return "Spotify";
        case URLType.YOUTUBE:
            return "YouTube";
        case URLType.SOUNDCLOUD:
            return "SoundCloud";
        default:
            return "Unknown";
    }
}

const isValidUrl = (urlString: string)=> {
    try { 
        return Boolean(new URL(urlString)); 
    }
    catch(e){ 
        return false; 
    }
}

function checkUrlAndAddHttp(url: string) {
    if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
    }
    return "https://" + url;
}

export function getTxoriaUrl() {
    return "https://txoria.org/";
}

function getDomainName(url: string): string {
  try {
    // Use the built-in URL class to parse the given URL
    const parsedUrl = new URL(url);
    // Extract and return the hostname (domain)
    return parsedUrl.hostname;
  } catch (error) {
    throw new Error("Invalid URL provided");
  }
}

export {getUrlType, URLType, getUrlTypeName, checkUrlAndAddHttp, isValidUrl, getDomainName}